import axios from "axios";
import router from "../router";
import Vue from "vue";

const qs = require("qs");

// Set up axios
const service = axios.create({
  baseURL: `${process.env.VUE_APP_API_BASE_URL}`, // Base url
  headers: {
    "Content-Type": "application/json"
  },
  paramsSerializer: params => qs.stringify(params),
  timeout: 12000 // Request timeout
});

// service.interceptors.request.use(
//   config => {
//     // If it doesn't start with http it means is our api, so add the authorization header
//     if (!config.url.startsWith("http") && localStorage.getItem("token")) {
//       config.headers["Authorization"] = `Bearer ${localStorage.getItem(
//         "token"
//       )}`;
//     }

//     return config;
//   },
//   error => {
//     Promise.reject(error);
//   }
// );

async function http(props) {
  try {
    return await service(props);
  } catch (error) {
    const message = error.response
      ? error.response.data.message || error.response.data.error.message
      : "Unknown Error";
    // Unauthorized: jwt expired
    if (error.response && error.response.status === 404) {
      router.push("/error");
      return;
    }
    Vue.ma.trackEvent({
      category: "Error",
      action:
        error.response && error.response.status
          ? `${error.response.status}`
          : "unknown",
      label: message
    });
    throw new Error(message);
  }
}

export default http;
